<template>
  <div class="feedback-info">
    <h4 class="title">
      Workers' feedback
      <!-- <div class="chevron-right">
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.41058 3.16083C7.73602 2.83539 8.26366 2.83539 8.58909 3.16083L14.8391 9.41083C15.1645 9.73626 15.1645 10.2639 14.8391 10.5893L8.58909 16.8393C8.26366 17.1648 7.73602 17.1648 7.41058 16.8393C7.08514 16.5139 7.08514 15.9863 7.41058 15.6608L13.0713 10.0001L7.41058 4.33934C7.08514 4.0139 7.08514 3.48626 7.41058 3.16083Z"
          />
        </svg>
      </div> -->
    </h4>
    <div class="content">
      <img :src="themeImage('star.svg')" class="star-icon" />
      <div>{{ averageReview }}/5</div>
      <font-awesome-icon class="circle" :icon="['fas', 'circle']" />
      <div>{{ props.reviews.length }} reviews</div>
    </div>
  </div>
</template>

<script setup>
import { themeImage } from '@/Theme';
import { computed } from 'vue';
import { getAverageRating } from '@/pages/talent-pool/utils/ratings';

const props = defineProps(['reviews']);

const averageReview = computed(() => {
  return getAverageRating(props.reviews);
});
</script>

<style scoped>
.feedback-info {
  border: 1px solid var(--palette-color-default-lighten-90);
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;

  /* &:hover {
    cursor: pointer;
    background-color: var(--palette-color-core-1-lighten-90);
    border: 1px solid var(--palette-color-brand-primary);

    .chevron-right svg path {
      fill: var(--palette-color-default);
    }
  } */
}

.circle {
  transform: scale(0.25);
}

.star-icon {
  width: 20px;
  margin-right: 6px;
}

.selected {
  border: 1px solid var(--palette-color-brand-primary);
  background-color: var(--palette-color-core-1-lighten-90);

  .chevron-right svg path {
    fill: var(--palette-color-default);
  }
}

.content {
  display: flex;
  flex-grow: 1;
  align-items: center;
}

.title {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.chevron-right {
  svg path {
    fill: var(--palette-color-default-lighten-50);
  }
}
</style>
